<template>
  <base-page-template
    component-name="TradeResultShowForData">

    <template #toolbar-items>
      <v-toolbar-title class="with-divider">
        取引データ一覧(データ実装単位)
      </v-toolbar-title>
    </template>

    <data-implementation-info
        :data-implementation="dataImplementationDetail">
    </data-implementation-info>

    <tab-item-template>
      <div style="position: relative;">
        <v-pagination
            v-model="page"
            :length="pageCount"
            :total-visible="15"
            class="py-3">
        </v-pagination>
        <message-table
          :messages="messages"
          :data-implementation-id="dataImplementationId">
        </message-table>
        <v-pagination
            v-model="page"
            :length="pageCount"
            :total-visible="15"
            class="py-3">
        </v-pagination>
        <v-overlay
            :value="loading"
            z-index="3"
            absolute>
          <v-progress-circular
              indeterminate
              size="64">
          </v-progress-circular>
        </v-overlay>
      </div>
    </tab-item-template>
  </base-page-template>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import gql from "graphql-tag";
import BetterSet from "betterset";
import PathInfoMixin from "@/router/PathInfoMixin";
import IoablePageMixin from "@/router/IoablePageMixin";
import BasePageTemplate from "@/components/templates/BasePageTemplate.vue";
import TabItemTemplate from "@/components/templates/TabItemTemplate.vue";
import MessageTable from "@/components/pages/contract/TradeResultShowForData/MessageTable.vue";
import DataImplementationInfo from "@/components/organisms/DataImplementationInfo.vue";

export default {
  name: 'TradeResultShowForData',
  components: {
    BasePageTemplate,
    TabItemTemplate,
    MessageTable,
    DataImplementationInfo
  },
  mixins: [
    PathInfoMixin,
    IoablePageMixin
  ],
  props: {
    dataImplementationId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      page: 1,
      pageCount: 0,
      perPage: 10,
      loading: true,
    };
  },
  computed: {
    ...mapState('hcs/dataImplementation', ['dataImplementation']),
    ...mapState('hcs/dataImplementation', ['messages']),
    ...mapGetters({
      hdsDb: 'hds/db',
      hdsEntities: 'hds/entities'
    }),
    dataImplementationDetail() {
      const dcm = this.hdsEntities.dataComponentModel.findOne({ id: this.dataImplementation.dataComponentModelId })
      return {
        ...this.dataImplementation,
        name: dcm?.name,
        description: dcm?.description
      };
    }
  },
  methods: {
    ...mapActions({
      gqlQueryAndLoad: 'hds/gqlQueryAndLoad'
    }),
    load() {
      this.hdsDb.clear()

      return Promise.all([
        this.$store.dispatch('hcs/dataImplementation/find', this.dataImplementationId),
        this.loadMessages(),
      ])
    },
    async loadMessages() {
      try {
        this.loading = true;
        const result = await this.$store.dispatch('hcs/dataImplementation/findMessageList', {
          id: this.dataImplementationId,
          page: this.page,
          perPage: this.perPage,
        });
        this.page = result.page;
        this.pageCount = Math.ceil(result.total / result.perPage);
      } finally {
        this.loading = false;
      }
    }
  },
  watch: {
    page: {
      handler() {
        this.loadMessages();
      }
    },
    dataImplementation: {
      immediate: true,
      handler(dataImplementation) {
        if(!dataImplementation || !dataImplementation.dataComponentModelId) {
          return;
        }

        this.gqlQueryAndLoad({
          query: gql`
              query FindDataComponentModel(
                  $dataComponentModelId: ID!,
              ) {
                  dataComponentModel: dataComponentModel(dataComponentModelId: $dataComponentModelId) {
                      id
                      name
                      description
                  }
              }`,
          variables: {
            dataComponentModelId: dataImplementation.dataComponentModelId
          },
          mapping: {
            dataComponentModel: 'dataComponentModel*'
          }
        });
      }
    }
  }
}
</script>
